import { nikon_Care_Logo } from "../assets/images";
import { router } from "../routes";
import LanguageSelector from "./LanguageSelector";

function Header() {
  const handleHome = () => {
    router.navigate("/");
  };

  return (
    <div
      className={`flex items-center gap-2 h-[70px] fixed top-0 w-full left-0 px-2 py-2 z-50 bg-gray-100`}
    >
      <div className="max-w-[628px] gap-4 flex items-center w-full justify-between mx-auto">
        <div className="main-logo">
          <div onClick={handleHome}>
            <img
              src={nikon_Care_Logo}
              alt={"nikon_Care_Logo"}
              className="mx-auto cursor-pointer"
            />
          </div>
        </div>
        <div className="language">
          <LanguageSelector color={"yellow"} />
        </div>
      </div>
    </div>
  );
}

export default Header;
